// export const base = 'body';

const regularVariant = {
  xl: 'text-body-xl sm:text-body-xl-sm md:text-body-xl-md xl:text-body-xl-xl',
  l: 'text-body-l sm:text-body-l-sm md:text-body-l-md xl:text-body-l-xl',
  m: 'text-body-m sm:text-body-m-sm md:text-body-m-md xl:text-body-m-xl',
  s: 'text-body-s sm:text-body-s-sm md:text-body-s-md xl:text-body-s-xl',
  xs: 'text-body-xs',
  xxs: 'text-body-xxs',
};

const boldVariant = {
  xl: 'text-body-xl sm:text-body-xl-sm md:text-body-xl-md xl:text-body-xl-xl',
  l: 'text-body-l-bold sm:body-l-bold-sm md:body-l-bold-md xl:body-l-bold-xl',
  m: 'text-body-m sm:text-body-m-sm md:text-body-m-md xl:text-body-m-xl',
  s: 'text-body-s-bold sm:body-s-bold-sm md:body-s-bold-md xl:body-s-bold-xl',
  xs: 'text-body-xs',
  xxs: 'text-body-xxs',
};

export const variant = (bold?: boolean) => (bold ? boldVariant : regularVariant);
